<template>
    <!-- 畅行卡-添加 -->
    <el-drawer title="添加信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="145px" style="height: 90vh; overflow-y: auto">
                    <el-form-item label="排序值:">
                        <el-input
                            v-model="submit_data.sort"
                            :placeholder="submit_rules.sort.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>

                    <el-form-item label="卡券名称:">
                        <el-input
                            v-model="submit_data.name"
                            :placeholder="submit_rules.name.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>

                    <el-form-item label="售价:">
                        <el-input
                            v-model="submit_data.price"
                            :placeholder="submit_rules.price.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>

                    <el-form-item label="限制次数:">
                        <el-input
                            v-model="submit_data.limit_num"
                            :placeholder="submit_rules.limit_num.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>

                    <el-form-item label="有效期（天）:">
                        <el-input
                            v-model="submit_data.expire"
                            :placeholder="submit_rules.expire.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>

                    <!-- <el-form-item label-width='50px'>
                        <el-switch v-model="all_order_isTrue" active-text="非全模式可用" inactive-text="全模式可用">
                        </el-switch>
                    </el-form-item> -->

                    <!-- 选择订单模式 -->
                    <!-- <el-form-item label="订单模式:" label-width='120px'
                        v-if="options_order_code.length!=0 && all_order_isTrue"> -->
                    <el-form-item label="订单模式:" label-width="120px">
                        <el-checkbox-group v-model="order_mode_code_array" size="mini">
                            <el-checkbox v-for="(item, index) in options_order_code" :label="item.code" border style="margin: 5px">
                                {{ item.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item label="抵扣规则:">
                        <div style="display: flex">
                            <el-select
                                v-model="submit_data.type"
                                :placeholder="submit_rules.type.placeholder"
                                style="width: 170px; margin-right: 20px"
                                clearable
                            >
                                <el-option label="免订单金额" value="1"> </el-option>
                                <el-option label="免起步价格" value="0"> </el-option>
                            </el-select>
                        </div>
                    </el-form-item>

                    <el-form-item label="一口价模式是否可用:">
                        <div style="display: flex">
                            <el-select
                                v-model="submit_data.kilo_step_mode"
                                :placeholder="submit_rules.kilo_step_mode.placeholder"
                                style="width: 170px; margin-right: 20px"
                                clearable
                            >
                                <el-option label="可用" value="1"> </el-option>
                                <el-option label="不可用" value="0"> </el-option>
                            </el-select>
                        </div>
                    </el-form-item>

                    <el-form-item label="短途特惠是否可用:">
                        <el-select
                            v-model="submit_data.short_distance"
                            :placeholder="submit_rules.short_distance.placeholder"
                            style="width: 170px; margin-right: 20px"
                            clearable
                        >
                            <el-option label="可用" value="1"> </el-option>

                            <el-option label="不可用" value="0"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否限制新用户:">
                        <el-select
                            v-model="submit_data.is_new_visit"
                            :placeholder="submit_rules.is_new_visit.placeholder"
                            style="width: 170px; margin-right: 20px"
                            clearable
                        >
                            <el-option label="是" value="1"> </el-option>

                            <el-option label="否" value="0"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否完善个人信息:">
                        <el-select
                            v-model="submit_data.is_perfect_user"
                            :placeholder="submit_rules.is_perfect_user.placeholder"
                            style="width: 170px; margin-right: 20px"
                            clearable
                        >
                            <el-option label="是" value="1"> </el-option>

                            <el-option label="否" value="0"> </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="司机承担（元）:">
                        <el-input
                            v-model="submit_data.driver_deduct"
                            :placeholder="submit_rules.driver_deduct.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="其他说明:">
                        <quill-editor ref="myTextEditor" v-model="submit_data.remark" :options="options"> </quill-editor>
                    </el-form-item>
                </el-form>

                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center">
                    <submitBtn
                        @onSubmitDig="onSubmitDig"
                        @toJSON="toJSON"
                        :data="submit_data"
                        :rules="submit_rules"
                        url="/card/addCard"
                        :JSON_Boolean="true"
                    ></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-drawer>
</template>

<script>
var _this;
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
export default {
    components: {
        quillEditor
    },
    props: {
        isShow: Boolean
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            // 获取订单模式
            _this.orderModeList();

           
        }
    },
    data() {
        return {
            // 订单模式查询条件
            mode_options_data: {
                page: 1,
                limit: 10,
                status: '1'
            },

            options: {
                placeholder: '如有需要在此输入其他说明',
                modules: {
                    toolbar: ''
                }
            },
            // 全模式可用开关
            // all_order_isTrue: false,
            //订单模式数据
            options_order_code: [],
            // 选中订单模式
            order_mode_code_array: [],
            show: false,
            // 表单数据
            submit_data: {
                sort: '',
                name: '',
                price: '',
                limit_num: '',
                expire: '',
                driver_deduct: '',
                order_mode_code_array: '',
                type: '',
                kilo_step_mode: '',
                short_distance: '',
                remark: '',
                is_new_visit: '',
                is_perfect_user: ''
            },

            submit_rules: {
                sort: {
                    placeholder: '排序值',
                    rules: {
                        required: true,
                        message: '排序值为0-999999的数字',
                        regulation: 'between',
                        rulesData: [0, 999999]
                    }
                },

                name: {
                    placeholder: '名称需在15字之内',
                    rules: {
                        required: true,
                        message: '名称需在15字之内',
                        regulation: 'elt_str',
                        rulesData: 15
                    }
                },

                price: {
                    placeholder: '精确至小数点后两位',
                    rules: {
                        required: true,
                        message: '价格输入错误',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                limit_num: {
                    placeholder: '纯数字，0表示无限次数',
                    rules: {
                        required: true,
                        message: '限制次数错误',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                expire: {
                    placeholder: '请输入有效期',
                    rules: {
                        required: true,
                        message: '有效期为大于0的数字',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                driver_deduct: {
                    placeholder: '请输入司机承担金额',
                    rules: {
                        required: true,
                        message: '司机承担金额为0-999.9的数字',
                        regulation: 'between',
                        rulesData: [0, 999.9]
                    }
                },
                order_mode_code_array: {
                    placeholder: '指定可用模式',
                    rules: {
                        required: false,
                        message: '模式错误',
                        regulation: 'egt_str',
                        rulesData: '0'
                    }
                },
                type: {
                    placeholder: '请选择抵扣规则',
                    rules: {
                        required: true,
                        message: '规则错误',
                        regulation: 'gt_str',
                        rulesData: '0|1'
                    }
                },
                kilo_step_mode: {
                    placeholder: '请选择一口价是否可用',
                    rules: {
                        required: true,
                        message: '一口价选择错误',
                        regulation: 'gt_str',
                        rulesData: '0|1'
                    }
                },
                short_distance: {
                    placeholder: '短途特惠是否可用',
                    rules: {
                        required: true,
                        message: '短途特惠是否可用',
                        regulation: 'gt_str',
                        rulesData: '0|1'
                    }
                },
                is_new_visit: {
                    placeholder: '是否限制为新用户',
                    rules: {
                        required: true,
                        message: '是否限制为新用户',
                        regulation: 'gt_str',
                        rulesData: '0|1'
                    }
                },
                is_perfect_user: {
                    placeholder: '是否完善个人信息',
                    rules: {
                        required: true,
                        message: '是否完善个人信息',
                        regulation: 'gt_str',
                        rulesData: '0|1'
                    }
                },

                remark: {
                    placeholder: '请输入其他说明',
                    rules: {
                        required: false,
                        message: '其他说明错误',
                        regulation: 'egt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        //获取订单模式
        orderModeList() {
            console.log('订单模式');
            _this.options_order_code = [];
            _this.getMode();
        },
        getMode() {
            _this
                .$post('/order/orderModeLists', _this.mode_options_data)
                .then((res) => {
                    // _this.options_order_code = res.data;
                    for (var i = 0; i < res.data.length; i++) {
                        _this.options_order_code.push({
                            code: res.data[i].order_mode.order_mode_code,
                            name: res.data[i].order_mode.name
                        });
                    }
                    console.log(_this.mode_options_data.page * _this.mode_options_data.limit < res.count, '--');

                    if (_this.mode_options_data.page * _this.mode_options_data.limit < res.count) {
                        _this.mode_options_data.page += 1;
                        _this.getMode();
                    } else {
                        _this.mode_options_data.page = 1;
                    }

                    console.log(_this.options_order_code, '_this.options_order_code');
                })
                .catch((err) => {});
        },

        // 数据提交前整理格式方法
        toJSON() {
            // 判断模式开关
            // if (_this.all_order_isTrue) {
            //     console.log(_this.all_order_isTrue);

            //     _this.submit_data.order_mode_code_array = JSON.stringify(_this.order_mode_code_array);

            // } else {

            //     _this.submit_data.order_mode_code_array = [];

            // }
            _this.submit_data.order_mode_code_array = JSON.stringify(_this.order_mode_code_array);
        },

        // 提交
        onSubmitDig() {
            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.mode_options_data= {
                page: 1,
                limit: 10,
                status: '1'
            };
            _this.submit_data = {
                sort: '',
                name: '',
                price: '',
                limit_num: '',
                expire: '',
                driver_deduct: '',
                order_mode_code_array: '',
                type: '',
                kilo_step_mode: '',
                short_distance: '',
                remark: '',
                is_new_visit: '',
                is_perfect_user: ''
            };
            console.log(_this.submit_data.remark);
            // _this.all_order_isTrue = false;
            _this.order_mode_code_array = [];
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}
</style>